module.exports = __webpack_public_path__ + "static/media/logo-theeconomist.7d666c92.jpg";